<template>
  <div class="artist-chicklet flex content-center items-center" v-if="artist">
    <div class="artist-chicklet__avatar bg-cover mr-4 rounded" :style="'background-image: url('+ artist.profileImage +'); width: 50px; height: 50px;'"></div>
    <div class="artist-chicklet__details flex-1">
      <strong class="artist-chicklet__details__title mb-1 block" v-html="artist.title"></strong>
      <div class="artist-chicklet__details__meta text-xxs text-grey-dark">
        <span class="mr-4" v-html="artist.postsCount + ' Posts'"></span>
        <span v-html="artist.followersCount + ' Followers'"></span>
      </div>
    </div>
    <div class="artist-chicklet__actions flex items-center">
      <i class="fas fa-user-plus text-white"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: ['artist']
}
</script>
